const toastState = {
  initial: "toast",
  states: {
    toast: {
      after: {
        2000: "hidden"
      }
    },
    hidden: {
      always: "#orderAndFight.select.alert"
    }
  }
}

export default {
  id: "orderAndFight",
  initial: "idle",
  states: {
    idle: {},
    select: {
      initial: "alert",
      states: {
        alert: {
          initial: "idle",
          entry: ["setSelectAlertInfo", "selectFightAndPayReport"],
          states: {
            idle: {
              on: {
                SELECT_ORDER: [
                  {
                    target: "#appActivity.participate.pay.forbidden",
                    actions: ["resetAlertInfo", "selectBuyProductReport"],
                    cond: "forbiddenBuy"
                  },
                  {
                    actions: ["resetAlertInfo", "selectBuyProductReport"],
                    target: "#appActivity.participate.pay.preCheck"
                  }
                ],
                CHECK_FIGHT: {
                  target: "#selectfreetask"
                },
                CLOSE_ALERT: {
                  actions: ["resetAlertInfo"],
                  target: "#orderAndFight.select.close"
                }
              }
            },
            selectfreetask: {
              id: "selectfreetask",
              initial: "checking",
              states: {
                checking: {
                  invoke: {
                    id: "checkTaskPreCondition",
                    src: "checkTaskPreCondition",
                    onDone: [
                      {
                        target: "checkSuccess.complete",
                        cond: "checkUserCanReceiveFightTask",
                        actions: ["selectBattledReport"]
                      },
                      {
                        target: "checkSuccess.todo",
                        actions: ["selectGoBattleReport"]
                      }
                    ],
                    onError: {
                      target: "checkFailure",
                      actions: ["registerTaskError", "checkBattleErrorReport"]
                    }
                  }
                },
                checkSuccess: {
                  initial: "idle",
                  states: {
                    idle: {},
                    todo: {
                      entry: ["jumpToFightGameSence"],
                      always: "#appActivity.participate"
                    },
                    complete: {
                      initial: "receiving",
                      states: {
                        receiving: {
                          invoke: {
                            id: "receiveFreeTask",
                            src: "participateTask",
                            onDone: [
                              {
                                target: "receiveSuccess"
                              }
                            ],
                            onError: [
                              {
                                target: "#selectfreetask.checkSuccess.todo",
                                cond: "checkJoinTaskError"
                              },
                              {
                                target: "receiveFailure",
                                actions: ["registerTaskError", "joinFreeTaskErrorReport"]
                              }
                            ]
                          }
                        },
                        receiveSuccess: {
                          initial: "alert",
                          states: {
                            alert: {
                              entry: ["setChanceAndLotteryAlertInfo", "updateFreeTaskScore"],
                              on: {
                                CLOSE_ALERT: {
                                  actions: ["resetAlertInfo"],
                                  target: "#orderAndFight.select.close"
                                },
                                SELECT_LOTTERY: {
                                  target: "#luckydraw.showDrawDialog.first",
                                  actions: [
                                    "setSelectedPresentRank",
                                    "setAvailableOpenPresentRank",
                                    "selectLotteryReport",
                                    "clickPresentReport",
                                    "resetCouponNum"
                                  ]
                                }
                              }
                            }
                          }
                        },
                        receiveFailure: {
                          ...toastState
                        }
                      }
                    }
                  }
                },
                checkFailure: {
                  ...toastState
                }
              }
            }
          }
        },
        close: {
          always: "#appActivity.participate"
        }
      }
    }
  }
}
